import { memo as n } from "react";
import { jsxs as r, jsx as t } from "react/jsx-runtime";
const d = n(({
  obj: e
}) => {
  const i = -e.size[0] * 0.5 + 0.1, s = e.size[0] * 0.5 - 0.1;
  return /* @__PURE__ */ r("g", {
    name: "window",
    children: [/* @__PURE__ */ t("line", {
      name: "left",
      x1: i,
      x2: i,
      y1: -e.size[2] * 0.5,
      y2: e.size[2] * 0.5,
      stroke: "#000",
      strokeWidth: 0.01
    }), /* @__PURE__ */ t("line", {
      name: "right",
      x1: s,
      x2: s,
      y1: -e.size[2] * 0.5,
      y2: e.size[2] * 0.5,
      stroke: "#000",
      strokeWidth: 0.01
    }), /* @__PURE__ */ t("line", {
      name: "middle",
      x1: i,
      x2: s,
      stroke: "#000",
      strokeWidth: 0.01
    })]
  });
});
d.displayName = "SvgWindow";
export {
  d as SvgWindow
};
//# sourceMappingURL=index9.js.map
